export default "__VITE_ASSET__BK1a$338__"